// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--fmAM9","wrapper--ie11":"wrapper--ie11--SnMt8","wrapperIe11":"wrapper--ie11--SnMt8"};